export default __webpack_public_path__ + "static/media/hoffs.dc43c28c.webp";